import * as http from 'axios'

export const login = (credentials) => {
  return http.post('/api/login/writeLabel', credentials)
}